import { all, call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import {
  getNegotiationDetails,
  confirmNegotiation,
  getDebtDetails,
  setDeal,
  getDealState,
  setForceRecalculation,
} from './actions';
import api from '../../services/api';

function* getNegotiationDetailsSaga(
  action: ReturnType<typeof getNegotiationDetails.request>
) {
  try {
    const negotiation: GQL.IOption[] = yield call(
      api.getNegotiationDetail,
      action.payload
    );
    yield put(getNegotiationDetails.success(negotiation));
  } catch {
    yield put(getNegotiationDetails.failure('Falha ao buscar propostas.'));
  }
}

function* setForceRecalculationSaga(
  action: ReturnType<typeof setForceRecalculation.request>
) {
  try {
    yield put(setForceRecalculation.success(action.payload));
  } catch {
    yield put(setForceRecalculation.failure('Falha ao forçar recalculo.'));
  }
}

function* confirmNegotiationSaga(
  action: ReturnType<typeof confirmNegotiation.request>
) {
  try {
    const options: GQL.IConfirmationInfo = yield call(api.confirmNegotiation, {
      options: action.payload.options,
      databaseId: action.payload.databaseId,
    });
    yield put(confirmNegotiation.success(options));
  } catch {
    yield put(confirmNegotiation.failure(null));
  }
}

function* getDebtDetailsSaga(
  action: ReturnType<typeof getDebtDetails.request>
) {
  try {
    const options: GQL.IDebtDetailInfo = yield call(api.getDebtDetails, {
      options: action.payload.options,
      databaseId: action.payload.databaseId,
    });
    yield put(getDebtDetails.success(options));
  } catch {
    yield put(getDebtDetails.failure(null));
  }
}

function* setDealSaga(action: ReturnType<typeof setDeal.request>) {
  try {
    const state: GQL.IState = yield call(api.setDeal, action.payload);
    if (state) {
      const data: GQL.IGetDealStateOnQueryArguments = {
        dealId: state.id ?? 0,
        contract: action.payload.options.contrato,
        databaseId: action.payload.databaseId,
      };
      const status: GQL.IState[] = yield call(api.getDealState, data);
      yield put(getDealState.success(status));
    }
    yield put(setDeal.success(state));
    // yield put(getAgreementDebt.request());
  } catch {
    yield put(setDeal.failure('Falha ao buscar propostas.'));
  }
}

function* getDealStateSaga(action: ReturnType<typeof getDealState.request>) {
  try {
    const status: GQL.IState[] = yield call(api.getDealState, action.payload);
    yield put(getDealState.success(status));
  } catch {
    yield put(setDeal.failure('Falha ao obter status do acordo.'));
  }
}

export default all([
  takeLatest(getNegotiationDetails.request, getNegotiationDetailsSaga),
  takeLatest(setForceRecalculation.request, setForceRecalculationSaga),
  takeLeading(confirmNegotiation.request, confirmNegotiationSaga),
  takeLeading(getDebtDetails.request, getDebtDetailsSaga),
  takeLatest(setDeal.request, setDealSaga),
  takeLatest(getDealState.request, getDealStateSaga),
]);
